// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__UmPcy","list":"Navbar_list__LfNtc","item":"Navbar_item__0XbxQ"};